// Tiny deterministic hash for label → tile color assignment.

export function hashStr(s) {
	let h = 5381;
	for (let i = 0; i < s.length; i++) {
		h = ((h << 5) + h) + s.charCodeAt(i);
		h |= 0;
	}
	return Math.abs(h);
}
